module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add-new-user"
  }, [_c('h1', {
    staticClass: "page-header color-1-100"
  }, [_vm._v("Create company account")]), _vm._v(" "), _c('div', {
    staticClass: "admin-breadcrumbs"
  }, [_c('router-link', {
    staticClass: "dashboard background-1-20 color-2-100",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Go to Dashboard")]), _vm._v(" "), _c('router-link', {
    staticClass: "all-users background-1-20 color-2-100",
    attrs: {
      "to": {
        name: 'companies'
      }
    }
  }, [_vm._v("Back to all companies list")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-block"
  }, [_c('div', {
    staticClass: "content-left-section"
  }, [_c('div', {
    ref: "companyDetails",
    staticClass: "content-section content-section__bordered border-1-20 add-user-section no-margin-top"
  }, [_c('div', [_c('div', {
    staticClass: "add-new-user-form"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [_vm._v("Add company details")]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-name"
    }
  }, [_vm._v("Company name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCompany.name),
      expression: "newCompany.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: [{
      'form-control form-control__input background-1-10-disabled  border-1-10-disabled has-error': _vm.errors.has('Company name')
    }, 'form-control form-control__input background-1-10-disabled  border-1-10-disabled'],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "new-company-name",
      "name": "Company name"
    },
    domProps: {
      "value": (_vm.newCompany.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newCompany, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Company name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Company name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-parent"
    }
  }, [_vm._v("Parent company")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Parent company')
    }],
    attrs: {
      "searchable": true,
      "options": _vm.preparedCompanies,
      "clearable": _vm.newCompany.parent !== null,
      "data-vv-name": "Parent company",
      "data-lpignore": "true",
      "name": "Company status",
      "id": "new-company-parent"
    },
    model: {
      value: (_vm.newCompany.parent),
      callback: function($$v) {
        _vm.$set(_vm.newCompany, "parent", $$v)
      },
      expression: "newCompany.parent"
    }
  }), _vm._v(" "), (this.errors.has('Parent company')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Parent company')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-industry"
    }
  }, [_vm._v("Industry")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Industry')
    }],
    attrs: {
      "searchable": false,
      "options": _vm.getIndustriesForSelect,
      "clearable": false,
      "data-vv-name": "Industry",
      "data-lpignore": "true",
      "name": "Industry",
      "id": "new-company-industry"
    },
    model: {
      value: (_vm.newCompany.industry),
      callback: function($$v) {
        _vm.$set(_vm.newCompany, "industry", $$v)
      },
      expression: "newCompany.industry"
    }
  }), _vm._v(" "), (this.errors.has('Industry')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Industry')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-language"
    }
  }, [_vm._v("Default language")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCompany.language),
      expression: "newCompany.language"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "type": "text",
      "disabled": "disabled",
      "data-lpignore": "true",
      "id": "new-company-language",
      "name": "Default language"
    },
    domProps: {
      "value": (_vm.newCompany.language)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newCompany, "language", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-types"
    }
  }, [_vm._v("User types")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('User types')
    }],
    attrs: {
      "searchable": true,
      "options": _vm.getDefaultRegistrationRolesForSelect,
      "data-vv-name": "User types",
      "data-lpignore": "true",
      "name": "User types",
      "id": "new-user-types"
    },
    model: {
      value: (_vm.newCompany.usersType),
      callback: function($$v) {
        _vm.$set(_vm.newCompany, "usersType", $$v)
      },
      expression: "newCompany.usersType"
    }
  }), _vm._v(" "), (this.errors.has('User types')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('User types')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "companySizes"
    }
  }, [_vm._v("Company size")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Company size')
    }],
    attrs: {
      "searchable": true,
      "options": _vm.companySizes,
      "data-vv-name": "Company size",
      "data-lpignore": "true",
      "name": "Company size",
      "id": "companySizes"
    },
    model: {
      value: (_vm.newCompany.companySize),
      callback: function($$v) {
        _vm.$set(_vm.newCompany, "companySize", $$v)
      },
      expression: "newCompany.companySize"
    }
  }), _vm._v(" "), (this.errors.has('Company size')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Company size')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "companyLocations"
    }
  }, [_vm._v("Company location")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Company location')
    }],
    attrs: {
      "searchable": true,
      "options": _vm.companyLocations,
      "data-vv-name": "Company location",
      "data-lpignore": "true",
      "name": "Company location",
      "id": "companyLocations"
    },
    model: {
      value: (_vm.newCompany.companyLocation),
      callback: function($$v) {
        _vm.$set(_vm.newCompany, "companyLocation", $$v)
      },
      expression: "newCompany.companyLocation"
    }
  }), _vm._v(" "), (this.errors.has('Company location')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Company location')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCompany.seesChat),
      expression: "newCompany.seesChat"
    }],
    staticClass: "form-control form-control__checkbox",
    class: [{
      'has-error': _vm.errors.has('Sees the Chat box')
    }],
    attrs: {
      "type": "checkbox",
      "data-lpignore": "true",
      "id": "new-company-chat",
      "name": "Sees the Chat box"
    },
    domProps: {
      "checked": Array.isArray(_vm.newCompany.seesChat) ? _vm._i(_vm.newCompany.seesChat, null) > -1 : (_vm.newCompany.seesChat)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newCompany.seesChat,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.newCompany, "seesChat", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.newCompany, "seesChat", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.newCompany, "seesChat", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-chat"
    }
  }, [_vm._v("Sees the Chat box")])]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCompany.isDemo),
      expression: "newCompany.isDemo"
    }],
    staticClass: "form-control form-control__checkbox",
    class: [{
      'has-error': _vm.errors.has('Demo company')
    }],
    attrs: {
      "type": "checkbox",
      "data-lpignore": "true",
      "id": "new-company-demo",
      "name": "Demo company"
    },
    domProps: {
      "checked": Array.isArray(_vm.newCompany.isDemo) ? _vm._i(_vm.newCompany.isDemo, null) > -1 : (_vm.newCompany.isDemo)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newCompany.isDemo,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.newCompany, "isDemo", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.newCompany, "isDemo", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.newCompany, "isDemo", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-demo"
    }
  }, [_vm._v("Demo company")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element form-element-date",
    attrs: {
      "id": "date-selector"
    }
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-subscription-end"
    }
  }, [_vm._v("Subscription ends on:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCompany.subscriptionEnd),
      expression: "newCompany.subscriptionEnd"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "new-company-subscription-end",
      "name": "Subscription ends"
    },
    domProps: {
      "value": (_vm.newCompany.subscriptionEnd)
    },
    on: {
      "focus": function($event) {
        _vm.datepicker.shown = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newCompany, "subscriptionEnd", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.datepicker.shown),
      expression: "datepicker.shown"
    }],
    staticClass: "datepicker"
  }, [_c('div', {
    staticClass: "datepicker-calendar-half"
  }, [_c('datepicker', {
    attrs: {
      "inline": true,
      "open-date": _vm.datepicker.subscription,
      "format": 'dd/MM/yyyy'
    },
    on: {
      "selected": function($event) {
        return _vm.dateSelected($event)
      }
    },
    model: {
      value: (_vm.datepicker.subscription),
      callback: function($$v) {
        _vm.$set(_vm.datepicker, "subscription", $$v)
      },
      expression: "datepicker.subscription"
    }
  })], 1)]), _vm._v(" "), (this.errors.has('Subscription ends')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Subscription ends')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-limit"
    }
  }, [_vm._v("Employee limit")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newCompany.employeeLimit),
      expression: "newCompany.employeeLimit"
    }],
    class: [{
      'form-control form-control__input background-1-10-disabled  border-1-10-disabled has-error': _vm.errors.has('Employee limit')
    }, 'form-control form-control__input background-1-10-disabled  border-1-10-disabled'],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "new-company-limit",
      "name": "Employee limit"
    },
    domProps: {
      "value": (_vm.newCompany.employeeLimit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newCompany, "employeeLimit", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Employee limit')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Employee limit')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-status"
    }
  }, [_vm._v("Company status")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Company status')
    }],
    attrs: {
      "searchable": false,
      "options": _vm.getStatusesForSelect,
      "clearable": _vm.newCompany.enabled !== null,
      "data-vv-name": "Company status",
      "data-lpignore": "true",
      "name": "Company status",
      "id": "new-company-status"
    },
    model: {
      value: (_vm.newCompany.enabled),
      callback: function($$v) {
        _vm.$set(_vm.newCompany, "enabled", $$v)
      },
      expression: "newCompany.enabled"
    }
  }), _vm._v(" "), (this.errors.has('Company status')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Company status')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "company-contraption"
    }
  }, [_vm._v("Company contraption")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCompany.contraption),
      expression: "newCompany.contraption"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Company contraption')
    }],
    staticStyle: {
      "text-transform": "uppercase"
    },
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "maxlength": "4",
      "id": "company-contraption",
      "name": "Company contraption"
    },
    domProps: {
      "value": (_vm.newCompany.contraption)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newCompany, "contraption", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    ref: "companyEmails",
    staticClass: "content-section content-section__bordered border-1-20 add-user-section"
  }, [_c('div', [_c('div', {
    staticClass: "add-new-user-form"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [_vm._v("Company registration settings")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "company-registration"
    }
  }, [_vm._v("Allow user registration")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Allow user registration')
    }],
    attrs: {
      "searchable": false,
      "options": _vm.yesNoOptionsForSelect,
      "data-vv-name": "Allow user registration",
      "data-lpignore": "true",
      "name": "Allow user registration",
      "id": "company-registration"
    },
    model: {
      value: (_vm.newCompany.allowRegistration),
      callback: function($$v) {
        _vm.$set(_vm.newCompany, "allowRegistration", $$v)
      },
      expression: "newCompany.allowRegistration"
    }
  }), _vm._v(" "), (this.errors.has('Allow user registration')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Allow user registration')))]) : _vm._e()], 1)]), _vm._v(" "), (_vm.newCompany.allowRegistration && _vm.newCompany.allowRegistration.value) ? _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-company-url"
    }
  }, [_vm._v("Company URL")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCompany.url),
      expression: "newCompany.url"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Company url')
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "new-company-url",
      "name": "Company url"
    },
    domProps: {
      "value": (_vm.newCompany.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newCompany, "url", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.newCompany.allowRegistration && _vm.newCompany.allowRegistration.value) ? _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "company-registration-all-emails"
    }
  }, [_vm._v("Only allow emails from an approved domain")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Allow all emails')
    }],
    attrs: {
      "searchable": false,
      "options": _vm.yesNoOptionsForSelect,
      "data-vv-name": "Allow all emails",
      "data-lpignore": "true",
      "name": "Allow all emails",
      "id": "company-registration-all-emails"
    },
    model: {
      value: (_vm.newCompany.allowAllEmails),
      callback: function($$v) {
        _vm.$set(_vm.newCompany, "allowAllEmails", $$v)
      },
      expression: "newCompany.allowAllEmails"
    }
  }), _vm._v(" "), (this.errors.has('Allow all emails')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Allow all emails')))]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.newCompany.allowRegistration && _vm.newCompany.allowRegistration.value) ? _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "company-registration-need-approval"
    }
  }, [_vm._v("New users must be approved by an admin")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Request approval')
    }],
    attrs: {
      "disabled": _vm.newCompany.allowRegistration && _vm.newCompany.allowRegistration.value,
      "searchable": false,
      "options": _vm.yesNoOptionsForSelectNew,
      "data-vv-name": "Request approval",
      "data-lpignore": "true",
      "name": "Request approval",
      "id": "company-registration-need-approval"
    },
    model: {
      value: (_vm.newCompany.emailApproval),
      callback: function($$v) {
        _vm.$set(_vm.newCompany, "emailApproval", $$v)
      },
      expression: "newCompany.emailApproval"
    }
  }), _vm._v(" "), (this.errors.has('Allow all emails')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Request approval')))]) : _vm._e()], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.newCompany.allowRegistration && _vm.newCompany.allowRegistration.value) ? _c('div', [_c('h3', {
    staticClass: "content-section-subtitle color-2-63"
  }, [_vm._v("Approved email domains")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "pasteEmails"
    }
  }, [_vm._v("Bulk paste")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailControl['input']),
      expression: "emailControl['input']"
    }],
    staticClass: "form-control form-control__textarea",
    attrs: {
      "data-lpignore": "true",
      "rows": "2",
      "id": "pasteEmails",
      "cols": "20"
    },
    domProps: {
      "value": (_vm.emailControl['input'])
    },
    on: {
      "paste": function($event) {
        _vm.emailControl['isPaste'] = true
      },
      "blur": function($event) {
        return _vm.createTags($event, false, true)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.emailControl, 'input', $event.target.value)
      }, function($event) {
        return _vm.createTags($event, true)
      }]
    }
  })])])]), _vm._v(" "), _vm._l((_vm.newCompany.approvedEmails), function(row, index) {
    return _c('div', {
      staticClass: "form-group form-group-half form-group__email-ending-input",
      class: [{
        'form-group-right-item': (index > 0 && (index + 1) % 2 === 0)
      }]
    }, [_c('div', {
      staticClass: "form-element"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.email),
        expression: "row.email"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "type": "text",
        "title": "Email",
        "aria-label": "Email",
        "data-lpignore": "true"
      },
      domProps: {
        "value": (row.email)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row, "email", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "form-group form-group-half form-group__email-ending-button form-group__email-ending-remove"
    }, [_c('div', {
      staticClass: "add-email-ending",
      on: {
        "click": function($event) {
          return _vm.removeElement(index)
        }
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half form-group__email-add-button"
  }, [_c('div', {
    staticClass: "add-email-ending",
    on: {
      "click": _vm.addEmailRow
    }
  }, [_vm._v("Add new")])])], 2) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    ref: "companyOwner",
    staticClass: "content-section content-section__bordered border-1-20 add-user-section"
  }, [_c('div', [_c('div', {
    staticClass: "add-new-user-form"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [_vm._v("Add account owner contact data")]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "owner-first-name"
    }
  }, [_vm._v("First name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ownerData.firstName),
      expression: "ownerData.firstName"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('First name')
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "owner-first-name",
      "name": "First name"
    },
    domProps: {
      "value": (_vm.ownerData.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ownerData, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('First name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('First name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "owner-phone"
    }
  }, [_vm._v("Phone number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ownerData.phoneNumber),
      expression: "ownerData.phoneNumber"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Phone number')
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "owner-phone",
      "name": "Phone number"
    },
    domProps: {
      "value": (_vm.ownerData.phoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ownerData, "phoneNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Phone number')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Phone number')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "owner-last-name"
    }
  }, [_vm._v("Last name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ownerData.lastName),
      expression: "ownerData.lastName"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Last name')
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "owner-last-name",
      "name": "Last name"
    },
    domProps: {
      "value": (_vm.ownerData.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ownerData, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Last name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Last name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-user-email"
    }
  }, [_vm._v("Email address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('email'),
      expression: "'email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.ownerData.email),
      expression: "ownerData.email"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Email')
    }],
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "new-user-email",
      "name": "Email"
    },
    domProps: {
      "value": (_vm.ownerData.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ownerData, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Email')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Email')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "content-right-section anchors"
  }, [_c('div', {
    staticClass: "sticky-anchors background-1-40-before"
  }, [_c('div', {
    staticClass: "anchor-item color-1-20 details",
    class: [{
      'active  color-1-100': _vm.activeSection === 'companyDetails'
    }]
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('companyDetails')
      }
    }
  }, [_vm._v("Add company details ")])]), _vm._v(" "), _c('div', {
    staticClass: "anchor-item color-1-20 email-endings",
    class: [{
      'active  color-1-100': _vm.activeSection === 'companyEmails'
    }]
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('companyEmails')
      }
    }
  }, [_vm._v("Add email endings")])]), _vm._v(" "), _c('div', {
    staticClass: "anchor-item color-1-20 owner",
    class: [{
      'active  color-1-100': _vm.activeSection === 'companyOwner'
    }]
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('companyOwner')
      }
    }
  }, [_vm._v("Add account owner contact data")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "add-new-user-control-panel"
  }, [_c('button', {
    staticClass: "clear-form",
    staticStyle: {
      "width": "280px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.discardAllData()
      }
    }
  }, [_vm._v("Cancel, discard all data")]), _vm._v(" "), _c('button', {
    staticClass: "submit-user",
    staticStyle: {
      "width": "280px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createNewCompany()
      }
    }
  }, [_vm._v("Create company account")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9054e428","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/AddCompany.vue
// module id = 1043
// module chunks = 0